import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
// import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  //   ActiveInactiveWeekendgateways,
  deleteWeekendgateways,
  getAllActiveWeekendgateways,
} from "./services/weekendgateways.services";
import {
  clearWeekendgatewaysID,
  setWeekendgatewaysID,
} from "./weekendgatewaysSlice";

const Weekendgateways: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllActiveWeekendgateways());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const handleCreate = () => {
    navigate("/weekendgateways/create");
  };

  return (
    <>
      <DeleteWeekendgatewaysDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Weekend Gateways List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <WeekendgatewaysGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const WeekendgatewaysGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const WeekendgatewaysList = useAppSelector(
    (state) => state.weekendgateways.WeekendgatewaysList
  );
  const loading = useAppSelector((state) => state.weekendgateways.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const [expandedRows, setExpandedRows] = useState(null);
  const truncateRemarkss = (ShortDescription: string) => {
    if (!ShortDescription) return "";
    const maxLength = 100;
    if (ShortDescription.length <= maxLength) return ShortDescription;
    return ShortDescription.substring(0, maxLength) + "...";
  };

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? WeekendgatewaysList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (ID: number) => {
      navigate("/weekendgateways/edit", { state: { WeekendgatewaysID: ID } });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteWeekendgateways"));
      dispatch(setWeekendgatewaysID(ID));
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => handleEdit(props.dataItem.ID)}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        // props.index === 1 ||
        props.index === 5 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {WeekendgatewaysList && WeekendgatewaysList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          className="responsive-table"
          filter={filter}
          data={
            filter
              ? filterBy(WeekendgatewaysList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : WeekendgatewaysList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={WeekendgatewaysList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Name"
            title="Name"
            width={200}
            cells={{
              data: (props: any) => (
                <td>
                  {isEditAccess ? (
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/weekendgateways/edit", {
                          state: { WeekendgatewaysID: props.dataItem?.ID },
                        })
                      }
                    >
                      {props.dataItem?.Name}
                    </div>
                  ) : (
                    <div className="normalName">{props.dataItem?.Name}</div>
                  )}
                </td>
              ),
            }}
          />
          <Column field="DisplayName" title="Display Name" width={200} />

          <Column
            width={250}
            field="ShortDescription"
            title="Short Description"
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="remarks-content"
                    dangerouslySetInnerHTML={{
                      __html:
                        expandedRows === props.dataItem?.ID
                          ? props.dataItem?.ShortDescription
                          : truncateRemarkss(props.dataItem?.ShortDescription),
                    }}
                  />
                  {props.dataItem?.ShortDescription?.length > 100 && (
                    <span
                      className="readmore-btn"
                      onClick={() =>
                        setExpandedRows(
                          expandedRows === props.dataItem?.ID
                            ? null
                            : props.dataItem?.ID
                        )
                      }
                    >
                      {expandedRows === props.dataItem?.ID
                        ? "Read Less"
                        : "Read More"}
                    </span>
                  )}
                </td>
              ),
            }}
          />

          <Column field="NoofNights" title="No of Nights" width={150} />

          <Column
            field="MainImage"
            title="Image"
            width={110}
            filterable={false}
            cells={{
              data: (props: any) => (
                <td className="text-center">
                  <Avatar
                    style={{
                      width: 45,
                      height: 45,
                      flexBasis: 45,
                    }}
                    rounded={"full"}
                    type={"image"}
                  >
                    <img
                      src={props.dataItem?.MainImage}
                      alt="Main Image"
                      width={200}
                      height={200}
                      onClick={() => window.open(props.dataItem?.MainImage)}
                    />
                  </Avatar>
                </td>
              ),
            }}
          />

          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cells={{ data: MyEditCommandCell }}
              width={"110px"}
              filterable={false}
              locked={true}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteWeekendgatewaysDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const WeekendgatewaysID = useAppSelector(
    (state) => state.weekendgateways.WeekendgatewaysID
  );
  const loading = useAppSelector((state) => state.weekendgateways.loading);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteWeekendgateways(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllActiveWeekendgateways());
        dispatch(closeDialog());
        dispatch(clearWeekendgatewaysID());
      } else {
        dispatch(getAllActiveWeekendgateways());
        dispatch(closeDialog());
        dispatch(clearWeekendgatewaysID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteWeekendgateways" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Weekendgateways"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Weekendgateways ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(WeekendgatewaysID)}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Weekendgateways;
